import { render } from "./FormComponent.vue?vue&type=template&id=9af2693e"
import script from "./FormComponent.vue?vue&type=script&lang=js"
export * from "./FormComponent.vue?vue&type=script&lang=js"
script.render = render

export default script